import React from 'react';
import Idea from '../../Components/Idea';

const PotentialIdeas = (props) => {
  return (
    <React.Fragment>
      <div>
        {Object.keys(props.ideas)
          .map((id) => {
            if(props.ideas[id].personaId === props.personaId) {
              return (
                <Idea
                  heading=""
                  personas={true}
                  milestone={props.methodName}
                  chosen={props.ideas[id].chosen}
                  id={id}
                  key={id}
                  ideaContent={props.ideas[id].ideaContent}
                  onDropdownSelected={props.onDropdownSelected}
                  openEditIdea={props.openEditIdea}
                />
              );
            } else {
              return;
            }
        })}
      </div>
    </React.Fragment>
  );
};

export default PotentialIdeas;
